import React, { Component } from 'react';
import passed from '../../../../assets/img/performances/PASSED_GREEN@2x.png';

class PerformanceBarPoints extends Component {
    hasReachedTarget() {
        const { incentive } = this.props;
        if (this.incentiveIsFixedTarget()){
            return incentive.packs_sold >= incentive.target_2
        } else {
            return incentive.packs_sold >= incentive.target
        }
    }

    hasReachedBaseTarget() {
        const { incentive } = this.props;
        return incentive.packs_sold >= incentive.base_target
    }

    performanceBarBGColor() {
        if (this.hasReachedTarget()) {
            return '#70bd4d';
        }
        return '#ffc734';
    }

    performanceBaseTargetBarBGColor() {
        if (this.hasReachedBaseTarget()) {
            return '#70bd4d';
        }
        return '#ffc734';
    }

    incentiveIsBaseTarget = () => {
        const { incentive } = this.props;
        return incentive.kind === 'base_target';
    }

    incentiveIsPacksSold = () => {
        const { incentive } = this.props;
        return incentive.kind === 'packs_sold';
    }

    incentiveIsFixedTarget = () => {
        const { incentive } = this.props;
        return incentive.kind === 'fixed_target';
    }

    render() {
        const { incentive } = this.props;
        let progress = Math.min(Math.floor((incentive.packs_sold / incentive.target) * 100), 100);
        let target1Progress, target2, target1 = 0;
        if (this.incentiveIsBaseTarget()){
            target1 = incentive.base_target;
            target2 = incentive.target;
            target1Progress = Math.min(Math.floor((target1 / target2) * 100), 100);
            progress = Math.min(Math.floor((incentive.packs_sold / target2) * 100), 100);
        } else if (this.incentiveIsFixedTarget()){
            target1 = incentive.target_1;
            target2 = incentive.target_2;
            target1Progress = Math.min(Math.floor((target1 / target2) * 100), 100);
            progress = Math.min(Math.floor((incentive.packs_sold / target2) * 100), 100);
        } else if (this.incentiveIsPacksSold()) {
            target2 = incentive.target;
            progress = Math.min(Math.floor((incentive.packs_sold / target2) * 100), 100);
        }

        return (
            <div className="performance-bar-wrapper performance-points-wrapper">
                {!this.hasReachedTarget() && (
                    <div className="sold-indicator" style={{ left: `calc(${progress}% - 15px)` }}>
                        <strong>{incentive.packs_sold}</strong>
                        <span className="glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span>
                    </div>
                )}
                <div className="performance-bar-back"></div>
                <div className="performance-bar" style={{ backgroundColor: this.performanceBarBGColor() }}></div>
                {this.incentiveIsBaseTarget() && (
                    <div className="performance-bar" style={{ left: 0, width: `${target1Progress}%`, zIndex: 10, backgroundColor: this.performanceBaseTargetBarBGColor() }}></div>
                )}
                <div className="performance-bar-overlay" style={{ width: `${100 - progress}%` }}></div>
                  <div>
                      <div className="target-indicator">
                          <div className="target-divider">
                              <span className="target-divider-left"></span>
                              <span className="target-divider-right"></span>
                          </div>
                          <div  className="target-label-container">
                          <div className="target-label">Target</div>
                          <div className="target-value"><strong>{target2}</strong></div>
                          </div>
                      </div>
                      {this.incentiveIsBaseTarget() && (
                          <div className="target-indicator" style={{ left: `calc(${target1Progress}% - 15px)` }}>
                              <div className="target-divider">
                                  <span className="target-divider-left"></span>
                                  <span className="target-divider-right"></span>
                              </div>
                              <div  className="target-label-container">
                              <div className="target-label">Target</div>
                              <div className="target-value"><strong style={{ color: this.performanceBaseTargetBarBGColor() }}>{target1}</strong></div>
                              </div>
                          </div>
                      )}
                      {this.incentiveIsFixedTarget() && (
                          <div className="target-indicator" style={{ left: `calc(${target1Progress}% - 15px)` }}>
                              <div className="target-divider">
                                  <span className="target-divider-left"></span>
                                  <span className="target-divider-right"></span>
                              </div>
                              <div className="target-label-container">
                                <div className="target-label">Target</div>
                                <div className="target-value"><strong style={{ color: this.performanceBaseTargetBarBGColor() }}>{target1}</strong></div>
                              </div>
                          </div>
                      )}
                  </div>
                {this.hasReachedTarget() && (
                    <div className="green-tick">
                        <div className="green-tick-text">
                            <strong>{incentive.packs_sold}</strong>
                        </div>
                        <div className="green-tick-image">
                            <img src={passed} />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default PerformanceBarPoints;



// WEBPACK FOOTER //
// ./src/components/common/store-performances/performance-bar/performance-bar-points.jsx